import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RoutingHistoryService {

  previousUrl: any;
  currentUrl: any;
  navigations: number;
  constructor() { }
}
